// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBar_container__h2My4","closeIcon":"NotificationBar_closeIcon__WXA6f","success":"NotificationBar_success__pVJFe","alert":"NotificationBar_alert__u2pmG"};